import React, { FunctionComponent } from 'react';

import { InsuredItem, SingleFieldStepProps } from 'scenes/common/types';
import SingleYesNoStep from 'scenes/common/components/Steps/SingleYesNoStep';

const HELP_TEXT =
  '5 acres is just over 2 hectares. The average suburban block is less than a quarter of an acre';
export const STATE_KEY = 'over5Acres';

const Over5AcresStep: FunctionComponent<
  Pick<SingleFieldStepProps<string>, 'onNext' | 'defaultStateValue'> & {
    insuredItem: InsuredItem;
  }
> = ({ onNext, defaultStateValue, insuredItem }) => {
  const question = `Is the ${insuredItem} to be insured on more than 5 acres of land?`;
  return (
    <SingleYesNoStep
      question={question}
      stateKey={STATE_KEY}
      helpText={HELP_TEXT}
      defaultStateValue={defaultStateValue}
      onNext={onNext}
    />
  );
};

export default Over5AcresStep;
